window.confirmSize = (event) => {
  const variant = product.variants.find((v) => v.id == event.detail.code);
  if (!variant) return;
  variant.options.forEach((optionValue, index) => {
    const optionName = product.options[index];
    const escapedOptionValue = optionValue.replace(/"/g, '\\"');
    const selector = `input[name^="${optionName}"][title="${escapedOptionValue}"]`;
    const element = document.querySelector(selector);
    element?.click();
  });
};

(function(){
  function handleVariantChange(evt){
    try {
      var data = evt && (evt.data || evt.detail) || {};
      var variant = data.variant || data.selectedVariant || {};
      var vid = variant.id || data.variantId || data.id;
      if(!vid) return;
      var widget = document.querySelector('#onlinesizing-widget');
      if(widget){ widget.setAttribute('variant-id', vid); }
    } catch(e) { /* no-op */ }
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS && PUB_SUB_EVENTS.variantChange) {
    subscribe(PUB_SUB_EVENTS.variantChange, handleVariantChange);
  } else {
    document.addEventListener('variant:change', handleVariantChange);
    document.addEventListener('variantChange', handleVariantChange);
    document.addEventListener('product:variant-change', handleVariantChange);
  }
})();